import { css, keyframes } from 'styled-components';

const draw = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

const fill = keyframes`
  from {
    fill-opacity: 0;
  }
  to {
    fill-opacity: 1;
  }
`;

const shine = keyframes`
  10% {
    opacity: 1;
    top: -30%;
    left: -30%;
    transition-property: left, top, opacity;
    transition-duration: 0.7s, 0.7s, 0.15s;
    transition-timing-function: ease;
  }
  100% {
    opacity: 0;
    top: -30%;
    left: -30%;
    transition-property: left, top, opacity;
  }
}
`;

export default css`
    .cpu {
        padding: 0 2px;

        //Draw gates
        &-gate-left,
        &-gate-right {
            width: 50%;
            height: 134px;
            position: absolute;
            top: 0;
            background-color: #f3f1ee; /* beige200 */
        }

        &-gate {
            &-left {
                left: 0;
            }
            &-right {
                right: 0;
            }
            &_open {
                width: 0;
                border: none;
                transition: width 0.5s ease-in-out;
            }
            &_close {
                width: 50%;
                transition: width 0.5s ease-in-out;
            }
        }

        &-core {
            width: 50px;
            height: 50px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin: -23px 0 0 -24px;
            overflow: hidden;
            &-shine-container {
                width: 50px;
                height: 50px;
            }
            &-shine {
                position: absolute;
                top: -110%;
                left: -210%;
                width: 180%;
                height: 180%;
                opacity: 0;
                transform: rotate(30deg);
                background: rgba(255, 255, 255, 0.13);
                background: linear-gradient(
                    to right,
                    rgba(255, 255, 255, 0.13) 0%,
                    rgba(255, 255, 255, 0.13) 77%,
                    rgba(255, 255, 255, 0.5) 92%,
                    rgba(255, 255, 255, 0) 100%
                );
                animation: ${shine} 3s ease-in-out forwards;
            }
            &-svg {
                width: 134px;
                height: 134px;
                margin-left: 0px;

                //Draw Shadow
                &-shadow {
                    fill-opacity: 0.1;
                }
                &-bg-shadow {
                    width: 48px;
                    height: 48px;
                }
                &-bg-shadow,
                &-AI-shadow,
                &-border-shadow {
                    fill: #141414; /* black */
                    opacity: 0.1;
                }

                // Draw CPU
                &-bg {
                    width: 52px;
                    height: 52px;
                    fill: #3c3b35; /* dark400 */
                }
                &-AI {
                    fill: #fff;
                }

                &_draw-cpu-pins {
                    fill: #3c3b35;
                    stroke: #3c3b35;
                    stroke-width: 2px;
                    fill-opacity: 0;
                    stroke-dasharray: 1000;
                    stroke-dashoffset: 1000;
                    animation-name: ${draw}, ${fill};
                    animation-fill-mode: forwards;
                    animation-duration: 8s, 1s;
                    animation-delay: 1s, 4s;
                }

                &_draw-cpu-pins-shadow {
                    fill: #141414; /* black */
                    stroke: #141414; /* black */
                    stroke-width: 2px;
                    fill-opacity: 0.1;
                    stroke-dasharray: 1000;
                    stroke-dashoffset: 1000;
                    animation-name: ${draw}, ${fill};
                    animation-fill-mode: forwards;
                    animation-duration: 8s, 1s;
                    animation-delay: 1s, 4s;
                }
            }
        }
    }
`;
